import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LI } from '../../../AbstractElements';
import { AccountContext } from '../../../GlobalComponents/Authentication/Accounts';
import { DropdownBuilder, VerticalButtonGroup } from '../../../GlobalComponents/Builders';
import { Button } from 'reactstrap';

const UserOptions = () => {

    const { logout, userSession } = useContext(AccountContext);
    const navigate = useNavigate();

    const logUserOut = () => {
        logout()
        window.location.href = process.env.PUBLIC_URL + '/login'
    }

    const goToProfile = () => {
        navigate('/users/user')
    }

    return (
        <Fragment>
            <LI attrLI={{ className: 'p-0' }} >
                <DropdownBuilder
                    label={`${userSession.name} `}
                    items={[
                        // {
                        //     label : 'Profile',
                        //     onClick: goToProfile
                        // },
                        {
                            label : 'Log Out',
                            onClick: logUserOut
                        },
                    ]}
                />
            </LI>
        </Fragment>
    );
};

export default UserOptions;